module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabs"
  }, [_c('div', {
    staticClass: "tabs__list"
  }, _vm._l((_vm.tabs), function(tab) {
    return _c('div', {
      staticClass: "tabs__list-item",
      class: {
        'tabs__list-item--active': tab.isActive
      },
      on: {
        "click": function($event) {
          return _vm.selectTab(tab.id)
        }
      }
    }, [_vm._v("\n      " + _vm._s(tab.name) + "\n    ")])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "tabs__content"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-abe3c03e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/common/tabs/Tabs.vue
// module id = 1981
// module chunks = 0